import { render, staticRenderFns } from "./PickPricePlanModal.vue?vue&type=template&id=94799400&"
import script from "./PickPricePlanModal.vue?vue&type=script&lang=ts&"
export * from "./PickPricePlanModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QRadio,QSeparator,QList,QItem,QItemSection,QCardActions} from 'quasar'
component.options.components = Object.assign({QChip,QRadio,QSeparator,QList,QItem,QItemSection,QCardActions}, component.options.components || {})
